import whenDomReady from 'when-dom-ready';
function initialise() {
    const search = document.querySelector('.js-search');
    const searchMobile = document.querySelector('.js-search-mobile');
    const searchInput = document.querySelector('.js-search-input');
    const searchClose = document.querySelector('.js-search-close');
    if (!search || !searchMobile || !searchInput || !searchClose) {
        return;
    }
    const searchInputField = searchInput.querySelector('input[type=search]');
    const OPEN = 'is-open';
    function handleClick() {
        if (searchInput === null) {
            return;
        }
        if (!searchInput.classList.contains(OPEN)) {
            searchInput.classList.add(OPEN);
            if (searchInputField) {
                searchInputField.focus();
            }
        }
    }
    search.addEventListener('click', handleClick);
    searchMobile.addEventListener('click', handleClick);
    searchClose.addEventListener('click', () => {
        if (searchInput.classList.contains(OPEN)) {
            search.classList.remove(OPEN);
            searchInput.classList.remove(OPEN);
        }
    });
}
whenDomReady().then(initialise);
